module.exports = __webpack_public_path__ + "static/media/old-paramount-logo.588aa933.png";